"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentMetadataDtoMimeTypeEnum = void 0;
exports.instanceOfAttachmentMetadataDto = instanceOfAttachmentMetadataDto;
exports.AttachmentMetadataDtoFromJSON = AttachmentMetadataDtoFromJSON;
exports.AttachmentMetadataDtoFromJSONTyped = AttachmentMetadataDtoFromJSONTyped;
exports.AttachmentMetadataDtoToJSON = AttachmentMetadataDtoToJSON;
exports.AttachmentMetadataDtoToJSONTyped = AttachmentMetadataDtoToJSONTyped;
/**
 * @export
 */
exports.AttachmentMetadataDtoMimeTypeEnum = {
    ImageJpeg: 'image/jpeg',
    ImagePng: 'image/png',
    ImageWebp: 'image/webp',
    ImageGif: 'image/gif',
    ApplicationPdf: 'application/pdf'
};
/**
 * Check if a given object implements the AttachmentMetadataDto interface.
 */
function instanceOfAttachmentMetadataDto(value) {
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    return true;
}
function AttachmentMetadataDtoFromJSON(json) {
    return AttachmentMetadataDtoFromJSONTyped(json, false);
}
function AttachmentMetadataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'mimeType': json['mimeType'],
    };
}
function AttachmentMetadataDtoToJSON(json) {
    return AttachmentMetadataDtoToJSONTyped(json, false);
}
function AttachmentMetadataDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'mimeType': value['mimeType'],
    };
}
//# sourceMappingURL=AttachmentMetadataDto.js.map